// extracted by mini-css-extract-plugin
module.exports = {"caret-up":"tooltip-component-module__0XEmZa__caret-up","tooltip":"tooltip-component-module__0XEmZa__tooltip"};